import React, { useState } from "react";
import { FcFeedback } from "react-icons/fc";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useParams } from "react-router";

const UnsubscribeMail = () => {
  const [status, setStatus] = useState(""); // Tracks the unsubscribe status
  const [feedback, setFeedback] = useState(""); // Stores user's feedback
  const [error, setError] = useState("");
  const { emailEncoded } = useParams();

  const handleUnsubscribe = async () => {
    try {
      // Simulate an API request to unsubscribe
      performRequest("POST", `/bulkemail/unsubscribe-email/`, {
        email: emailEncoded,
        feedback: feedback,
      })
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Email service unsubscribed!");
          }
          if (res.status === 200) {
            Toast("success", res.data?.message);
          }
        })
        .catch((err) => {
          Toast("error", "Internal Error");
          console.error(err);
        });
      setStatus("success");
    } catch (err) {
      setError("Failed to unsubscribe. Please try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow-lg p-4"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <FcFeedback size={50} />
        </div>
        <h1 className=" text-center mb-3">You've Been Unsubscribed</h1>
        <p className="text-center text-muted mb-3">
          We're sorry to see you go! Please let us know why you decided to
          unsubscribe.
        </p>
        {status !== "success" ? (
          <form>
            <div className="mb-3">
              <textarea
                className="form-control"
                rows="4"
                placeholder="Your feedback (optional)"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <button
              type="button"
              className="btn btn-danger w-100"
              onClick={handleUnsubscribe}
            >
              UNSUBSCRIBE
            </button>
          </form>
        ) : (
          <div className="alert alert-success py-2 text-center">
            Thank you for your feedback! You've been unsubscribed successfully.
          </div>
        )}
      </div>
    </div>
  );
};

export default UnsubscribeMail;
